import axios from 'axios';
import $store from '../store'
import store from '../store/index'

const base = process.env.VUE_APP_BACKEND_URL;
const baseUrl = `${base}/api`;
const axiosInstance = axios.create({
    baseURL: baseUrl,
    withCredentials: true,
});

// Add a request interceptor
axiosInstance.interceptors.request.use(function (config) {
    // eslint-disable-next-line no-undef
    sso.appendHeadersToRequest(function (key, value) {
        config.headers[key] = value;
    });
    const hash = location.hash.substring(1);
    let splitted = hash.split('?');
    if (splitted.length > 1) {
        const urlParams = new URLSearchParams('?' + splitted[1]);
        let key = urlParams.get('key');
        if (key) {
            config.params = {...config.params, key: key};
        }
    }
    config.withCredentials = true;
    if (location.href.indexOf("stage=1") !== -1) {
        config.baseURL = "https://adcontrol-backend-stage.adalliance.io";
        config.url = config.url.replace('/service.php', '/api');
    }
    return config;
});

axiosInstance.interceptors.response.use(function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    if (response.data && ((typeof response.data.status !== 'undefined' && response.data.status === 'redirect') || (typeof response.data.loginStatus !== "undefined" && !response.data.loginStatus))) {
        store.commit('updateSsoLoginRes', response.data);
        //location.href = response.data.url;
    } else {
        if (!response.data.Status && typeof response.data.StatusMessage !== "undefined" && response.data.StatusMessage !== "") store.commit('errorMessage', response.data.StatusMessage);
        if (typeof response.data.User !== "undefined" && typeof response.data.User.UserId === "undefined") {
            //response.data.User.Group = 'native';
            if ($store.getters['users/role'] === null || $store.getters['users/role'] !== response.data.User.Group) {
                store.commit('users/setUserRole', response.data.User.Group);
                if (response.data.User.Group === 'read' && store.state.readOnly !== 1) store.commit('updateReadOnly', 1);
            }
        }
        return response;
    }
}, function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    let returnError = error;
    if (typeof error.response !== "undefined" && Object.prototype.hasOwnProperty.call(error.response, 'data')) {
        let errorMessage = error.response.data.message ?? error.response.data;
        if (Object.prototype.hasOwnProperty.call(error.response.data, 'errors')) {
            for (let key in error.response.data.errors) {
                if (Object.prototype.hasOwnProperty.call(error.response.data.errors, key)) {
                    errorMessage += '\n' + key + ': ';
                    for (let i = 0; i < error.response.data.errors[key].length; i++) {
                        errorMessage += error.response.data.errors[key][i] + '. ';
                    }
                }
            }
        }
        returnError = new Error(errorMessage);
    }
    store.commit('errorMessage', returnError.__CANCEL__ ? 'Abgebrochen' : returnError.message);
    return Promise.reject(returnError);
});

export default axiosInstance;